import { render, staticRenderFns } from "./CustomerChart.vue?vue&type=template&id=3d72dc37&scoped=true&"
import script from "./CustomerChart.vue?vue&type=script&lang=js&"
export * from "./CustomerChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d72dc37",
  null
  
)

export default component.exports